import React, { lazy, Suspense } from "react";
import { useFormikContext } from "formik";
import { useReplaceMessage } from "../../../hooks/useReplaceMessage";
import { useReplaceEmoji } from "../hooks/useReemplaceEmoji";
const ReactDevicePreview = lazy(() => import("react-device-preview"));
import _Carrousel from "./device-preview/_Carrousel";
import MessageButtons from "./device-preview/MessageButtons";
import MessageMedia from "./device-preview/MessageMedia";
import PropTypes from "prop-types";
import { classNames } from "../../../utils/helpers";
const HeaderChat = () => {
  return (
    <div className="flex items-center gap-3 border-b border-gray-200 bg-white w-full px-4 py-3 flex-shrink-0">
      <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
        <span className="text-white font-bold text-sm">ODT</span>
      </div>
      <div>
        <div className="font-semibold text-gray-800">ODT</div>
        <div className="text-xs text-green-600">En línea • RCS</div>
      </div>
    </div>
  );
};

export const MessageChat = () => {
  const { values } = useFormikContext();
  const replaceMessage = useReplaceMessage(values.fieldsInfo);
  const replaceEmoji = useReplaceEmoji();

  const message = replaceMessage(values.rcsmessage);
  const emojiReplace = replaceEmoji(message);

  const renderContent = () => {
    switch (values.step) {
      case 1:
        return (
          <div className="p-4">
            <div className="text-gray-600 text-sm mb-3 min-h-[48px] break-words whitespace-pre-wrap">
              {emojiReplace || "Escriba su mensaje"}
            </div>

            <MessageButtons
              actions={values.buttonActions}
              quickReplies={values.buttonQuickReplies}
            />
          </div>
        );

      case 2:
        return (
          <>
            {/* Mensaje multimedia 
            estan invertidos, horizontal/vertical se refiere al texto
            */}
            <div
              className={classNames("flex overflow-hidden", {
                "flex-col":
                  values.cardOrientation === "VERTICAL" ||
                  !values.cardOrientation,
                "flex-row": values.cardOrientation === "HORIZONTAL",
              })}
            >
              <div
                className={classNames({
                  "w-full h-auto": values.cardOrientation === "HORIZONTAL",
                })}
              >
                <MessageMedia media={values.imageUrl} />
              </div>
              <div className="p-4 min-w-0">
                <div className="font-semibold text-xl text-gray-800 mb-1 break-words">
                  {values.title_rcs_message}
                </div>
                <div className="text-gray-600 text-sm mb-3 min-h-[48px] break-words whitespace-pre-wrap">
                  {emojiReplace || "Escriba su mensaje"}
                </div>
              </div>
            </div>
            <div className="m-2">
              <MessageButtons
                actions={values.buttonActions}
                quickReplies={values.buttonQuickReplies}
              />
            </div>
          </>
        );

      case 3:
        return (
          <div className="p-4 overflow-x-auto">
            <div className="flex gap-4">
              <_Carrousel data={values.carrousel} />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="flex-1 px-4 py-2 space-y-3 overflow-y-auto">
      <div className="flex justify-end">
        <div className="w-full bg-white rounded-2xl border border-gray-200 shadow-sm min-h-[180px] flex flex-col justify-between">
          {/* Contenido */}
          {renderContent()}

          {/* Footer del mensaje */}
          <div className="px-4 py-2 bg-gray-50 border-t border-gray-200 flex justify-between items-center text-xs text-gray-500">
            <span>10:32 AM</span>
            <div className="flex items-center gap-1">
              <span>Entregado • Leído</span>
              <svg
                className="w-4 h-4 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FooterChat = () => {
  return (
    <div className="border-t bg-white px-4 py-3 flex items-center gap-2 flex-shrink-0">
      <input
        type="text"
        placeholder="Escribe un mensaje RCS..."
        className="flex-1 border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:border-blue-500"
        disabled
      />
      <div className="bg-blue-500 text-white w-10 h-10 rounded-full flex items-center justify-center border-none focus:outline-none">
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
          />
        </svg>
      </div>
    </div>
  );
};

export const Device = (props) => {
  const { scale = "0.70", position = "center", device = "galaxynote8" } = props;
  return (
    <Suspense fallback={<div className="p-5 text-center">Cargando…</div>}>
      <ReactDevicePreview device={device} scale={scale} position={position}>
        <div className="w-full h-full bg-gray-50 flex flex-col">
          {/* Encabezado del chat */}
          <HeaderChat />

          {/* Área de mensajes con scroll */}
          <MessageChat />

          {/* Área de entrada */}
          <FooterChat />
        </div>
      </ReactDevicePreview>
    </Suspense>
  );
};

Device.propTypes = {
  scale: PropTypes.string,
  position: PropTypes.string,
  orientation: PropTypes.string,
  device: PropTypes.string,
};

const DevicePreview = () => {
  return (
 <div className="flex justify-center w-100% fixed">
      <Device />
    </div>
  );
};

export default DevicePreview;
